import { render } from "./PtResourceForm.vue?vue&type=template&id=0b80427c&scoped=true"
import script from "./PtResourceForm.vue?vue&type=script&lang=js"
export * from "./PtResourceForm.vue?vue&type=script&lang=js"

import "./PtResourceForm.vue?vue&type=style&index=0&id=0b80427c&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b80427c"]])

export default __exports__